import React from "react";
import {
  Clock, Loader2, CheckCircle2, XCircle, Ban, AlertTriangle,
} from "lucide-react";

const MAP = {
  Pending: { cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: Clock },
  Processing: { cls: "bg-sky-50 text-sky-700 border-sky-200", Icon: Loader2 },
  Paid: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: CheckCircle2 },
  Failed: { cls: "bg-rose-50 text-rose-700 border-rose-200", Icon: XCircle },
  Cancelled: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: Ban },
  Expired: { cls: "bg-amber-50 text-amber-700 border-amber-200", Icon: AlertTriangle },
};

export const PaymentStatusBadge = ({ status, className = "" }) => {
  const cfg = MAP[status] || MAP.Pending;
  const { Icon } = cfg;
  const spin = status === "Processing";
  return (
    <span
      data-testid={`payment-status-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${cfg.cls} ${className}`}
    >
      <Icon className={`h-3.5 w-3.5 ${spin ? "animate-spin" : ""}`} />
      {status}
    </span>
  );
};
